// deno-fmt-ignore-file
import { ExtendsLeft } from './extends-left.mjs';
import { EnumToUnion } from '../engine/enum/index.mjs';
export function ExtendsEnum(inferred, left, right) {
    return ExtendsLeft(inferred, EnumToUnion(left), right);
}
